import { defineStore } from 'pinia'
import { stringify, parse } from 'zipson'
import _ from 'lodash'
import { IDropdownOption, IStore, IStoreObject } from 'src/common/interfaces'

interface IState {
  all_stores: IDropdownOption[]
  all_store_ids: number[]
  stores: IDropdownOption[]
  store_ids: number[]
  selected_stores: IDropdownOption | IDropdownOption[]
  selected_store_ids: number | number[]
  all_store_objects: IStoreObject
  last_update: string
}

export const useBranchesStore = defineStore('branches', {
  // prettier-ignore
  state: (): IState => ({
    all_stores: [],
    all_store_ids: [],
    stores: [],
    store_ids: [],
    selected_stores: [],
    selected_store_ids: [],
    all_store_objects: {},
    last_update: ''
  }),
  getters: {
    isMultiBranch(): boolean {
      return Boolean(this.all_store_ids.length && this.all_store_ids.length > 1)
    },
    showBranchFilter(): boolean {
      return this.isMultiBranch && this.store_ids.length > 1
    },
    getSelectedStoreIds(): number {
      return typeof this.selected_store_ids === 'number' ? this.selected_store_ids : this.selected_store_ids[0]
    },
    getStores(): IDropdownOption[] {
      return _.cloneDeep(this.stores)
    },

    getStoreId(): number {
      return typeof this.selected_store_ids === 'number' ? this.selected_store_ids : this.selected_store_ids[0]
    },
  },
  /* ------------------------------- All Stores ------------------------------- */
  actions: {
    setAllStores(stores: IDropdownOption[]) {
      this.all_stores = stores
    },
    addToAllStores(store: IStore) {
      this.all_stores.push({ label: store.name, value: store.id })
    },
    modifyStoreFromAllStores(store: IStore) {
      const index = this.all_stores.findIndex((s) => s.value === store.id)
      Object.assign(this.all_stores[index], store)
    },
    setAllStoresIds(store_ids: number[]) {
      this.all_store_ids = store_ids
    },
    addToAllStoresIds(store_id: number) {
      this.all_store_ids.push(store_id)
    },

    /* --------------------------------- Stores --------------------------------- */
    setStores(stores: IDropdownOption[]) {
      this.stores = stores
    },
    addToStores(store: IStore) {
      this.stores.push({ label: store.name, value: store.id })
    },
    modifyStoreFromStores(store: IStore) {
      const index = this.stores.findIndex((s) => s.value === store.id)
      Object.assign(this.stores[index], store)
    },
    setStoresIds(store_ids: number[]) {
      this.store_ids = store_ids
    },
    addToStoresIds(store_id: number) {
      this.store_ids.push(store_id)
    },

    /* ----------------------------- Selected Stores ---------------------------- */
    setSelectedStores(selected_stores: IDropdownOption | IDropdownOption[]) {
      this.selected_stores = selected_stores
    },
    setSelectedStoreIds(selected_store_ids: number | number[]) {
      this.selected_store_ids = selected_store_ids
    },

    handleGetStoreById(id: number) {
      return this.stores.find((store) => store.value === id) || null
    },

    /* ---------------------------- All Store Objects --------------------------- */
    setAllStoreObjects(stores: IStore[]) {
      for (const store of stores) {
        this.all_store_objects[store.id] = store
      }
    },
    addToAllStoreObjects(store: IStore) {
      this.all_store_objects[store.id] = store
    },

    /* --------------------------------- Remove --------------------------------- */
    removeStore(storeId: number, protectedStoreId: number) {
      if (storeId !== protectedStoreId) {
        this.all_stores = this.all_stores.filter((s) => s.value !== storeId)
        this.all_store_ids = this.all_store_ids.filter((id) => id !== storeId)
        this.stores = this.stores.filter((s) => s.value !== storeId)
        this.store_ids = this.store_ids.filter((id) => id !== storeId)

        if (Array.isArray(this.selected_stores)) {
          this.selected_stores = this.selected_stores.filter((s) => s.value !== storeId)
          if (!this.selected_stores.length) this.selected_stores = [this.stores[0]]
        } else this.selected_stores = this.stores[0]

        if (typeof this.selected_store_ids === 'object' && Array.isArray(this.selected_store_ids)) {
          this.selected_store_ids = this.selected_store_ids.filter((id) => id !== storeId)
          if (!this.selected_store_ids.length) this.selected_store_ids = [this.store_ids[0]]
        } else this.selected_store_ids = this.store_ids[0]

        delete this.all_store_objects[storeId]
      }
    },
  },
  persist: {
    key: 'branches',
    // paths: ['stores', 'store_ids'],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },
})
